module.exports = __webpack_public_path__ + "img/keyun03.211295a5.png";